import React, { useState } from 'react'
import ExhibitorCard from './ExhibitorCard'
import AzFilter from './AzFilter'
import { byExhibitor } from '../../functions/exhibitorViews'
import { LABELS } from '../../constants/staticText'
import groupByInitial from '../../../client/functions/groupByInitial'

const ExhibitorsWithProfessions = ({ data, themesPath, LinkComponent }) => {
    const [letter, setLetter] = useState('')
    const all = byExhibitor(data)
    const shown = letter
        ? (groupByInitial(all, 'name').find(g => g.letter === letter)?.items || [])
        : all

    if (0 === all.length) return <p className="section-empty">{LABELS.noExhibitors}</p>

    return (
        <div className="section-exhibitors">
            <AzFilter items={all} active={letter} onSelect={setLetter} />
            <div className="exhibitor-cards">
                {shown.map(exhibitor => (
                    <ExhibitorCard key={exhibitor.participantId} exhibitor={exhibitor} themesPath={themesPath} LinkComponent={LinkComponent} />
                ))}
            </div>
        </div>
    )
}

export default ExhibitorsWithProfessions
